import React from "react";
import {
  AdvancedMarker,
  AdvancedMarkerAnchorPoint,
} from "@vis.gl/react-google-maps";

// Imported assets
import blueIcon from "../../../../assets/images/map/BlueIcon_Small.png";
import greenIcon from "../../../../assets/images/map/GreenIcon_Small.png";
import redIcon from "../../../../assets/images/map/RedIcon_Small.png";
import yellowIcon from "../../../../assets/images/map/YellowIcon_Small.png";

const Marker = ({
  data,
  position,
}) => {
  // Determines the icon for a marker based on the location's status
  const chooseMarkerIcon = (locationStatus, maintenanceStatus) => {
    if (locationStatus === "Cyber Attack") {
      return yellowIcon;
    } else if (maintenanceStatus) {
      return blueIcon;
    } else if (locationStatus === "Faulted") {
      return redIcon;
    } else {
      // locationStatus === "Available" OR default
      return greenIcon;
    }
  };

  return (
    <AdvancedMarker
      anchorPoint={AdvancedMarkerAnchorPoint.CENTER}
      className={"marker feature"}
      position={position}
      title={data.locName}
      zIndex={Number.MAX_SAFE_INTEGER}
    >
      <img
        height={24}
        src={chooseMarkerIcon(data.locationStatusType.codeName, data.maintenanceActive)}
        width={24}
      />
    </AdvancedMarker>
  );
};

export default Marker;
